// ts-rest contract for the MCP admin surface (Track:oauth / F6, ADR-0006).
//
// Firm admin only (`@Persona('admin')` on the controller). Lists who has
// connected the MCP surface and under which OAuth client, and lets an admin
// revoke a connection or remove a stale client. No token/hash/secret material
// crosses this wire — see schemas/mcp-admin.ts.
//
// Endpoints under /api/mcp-admin:
//   GET  /api/mcp-admin/connections     — the (user × client) connection list
//   GET  /api/mcp-admin/clients         — registered DCR clients + live counts
//   POST /api/mcp-admin/revoke          — revoke a user's access (one/all clients)
//   POST /api/mcp-admin/clients/remove  — remove a client (revokes its tokens)

import { initContract } from '@ts-rest/core';
import {
    mcpConnectionsResponseSchema,
    mcpClientsResponseSchema,
    mcpRevokeAccessRequestSchema,
    mcpRemoveClientRequestSchema,
    mcpAdminMutationResponseSchema,
} from '../schemas/mcp-admin';

const c = initContract();

export const mcpAdminContract = c.router(
    {
        listConnections: {
            method: 'GET',
            path: '/mcp-admin/connections',
            responses: {
                200: mcpConnectionsResponseSchema,
            },
            summary: 'List every MCP connection (user × client) with its live grant and status',
        },
        listClients: {
            method: 'GET',
            path: '/mcp-admin/clients',
            responses: {
                200: mcpClientsResponseSchema,
            },
            summary: 'List registered MCP OAuth clients with their live-connection counts',
        },
        revokeAccess: {
            method: 'POST',
            path: '/mcp-admin/revoke',
            body: mcpRevokeAccessRequestSchema,
            responses: {
                200: mcpAdminMutationResponseSchema,
            },
            summary: "Revoke a user's MCP access — one client, or all when clientId is omitted",
        },
        removeClient: {
            method: 'POST',
            path: '/mcp-admin/clients/remove',
            body: mcpRemoveClientRequestSchema,
            responses: {
                200: mcpAdminMutationResponseSchema,
            },
            summary: 'Remove a registered client, revoking its tokens in the same transaction',
        },
    },
    {
        pathPrefix: '/api',
        strictStatusCodes: false,
    },
);
